import { FIELD_SIZE, INPUT_FIELD_TYPE, INPUT_TYPE } from '@components/DynamicFormField/constant';
import { getUserBeneficiaries, updateBeneficiaryVerificationData } from '@store/actions/usersActions';


/**
 *
 * @type {{title: string, updateBeneficiaryFieldsConfig: (function(): *)}}
 */
const getUpdateBeneficiaryFieldConfig = (beneficiaryData) => {
  return [
    {
      key: "accountHolderName",
      name: "accountHolderName",
      value: beneficiaryData?.accountHolderName,
      label: `Account Holder Name`,
      caption: null,
      placeholder: "Enter the Account Holder Name",
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      fieldSize: FIELD_SIZE.MEDIUM,
      maxLength: 100,
      width: 'auto',
      isEditable: true,
      isRequired: true,
    },
    {
      key: "accountNumber",
      name: "accountNumber",
      value: beneficiaryData?.accountNumber,
      label: `Account Number`,
      caption: null,
      placeholder: "Enter the Account Number",
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.NUMBER,
      fieldSize: FIELD_SIZE.MEDIUM,
      maxLength: 20,
      width: 'auto',
      isEditable: false,
      isRequired: false,
    },
    {
      key: "ifscCode",
      name: "ifscCode",
      value: beneficiaryData?.ifscCode,
      label: `IFSC Code`,
      caption: null,
      placeholder: "Enter the IFSC Code",
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      fieldSize: FIELD_SIZE.MEDIUM,
      maxLength: 20,
      width: 'auto',
      isEditable: false,
      isRequired: false,
    },
    {
      key: "bankName",
      name: "bankName",
      value: beneficiaryData?.bankName,
      label: `Bank Name`,
      caption: null,
      placeholder: "Enter the Bank Name",
      fieldType: INPUT_FIELD_TYPE.INPUT,
      inputType: INPUT_TYPE.STRING,
      fieldSize: FIELD_SIZE.MEDIUM,
      maxLength: 50,
      width: 'auto',
      isEditable: false,
      isRequired: false,
    },
  ];
};

const payloadConverter = ({
  formData,
  beneficiaryData
}) => {
  return {
    ...beneficiaryData,
    accountHolderName: formData.accountHolderName
  }
}



export const beneficiaryConfig = {
  title: 'Beneficiary Details',
  getUserBeneficiaries: ({userId}) => getUserBeneficiaries({
    userId
  }),
  updateBeneficiaryFieldsConfig: (beneficiaryData) => getUpdateBeneficiaryFieldConfig(beneficiaryData),
  updateBeneficiaryDetails: ({ userId, beneficiaryId, payload, onSuccess, onComplete}) =>   updateBeneficiaryVerificationData
  ({
    userId,
    beneficiaryId,
    payload,
    onSuccess,
    onComplete
  }),
  updateBeneficiaryDetailsPayloadConverter: ({beneficiaryData, formData}) => payloadConverter({formData, beneficiaryData})
}